import api from './base/standardApi';

const EventsApi = {
  getEventByAccount( id: string, params?: any ) {
    return api.get( `api/evento/GetByCuentaInversion/${id}`, params );
  },
  getEventsByPromotion( id: number ) {
    return api.get( `api/evento/GetByPromocion/${id}` );
  },
  getAllEvents( params:any ) {
    return api.get( 'api/evento/GetAll', params );
  },
  getEventById( id: number, eventId: number ) {
    return api.get( `api/evento/GetByIdAsync/${id}/${eventId}` );
  },
  createAdminEvent( promocionId: string, data:any ) {
    return api.post( `api/evento/Create/${promocionId}`, data );
  },
  editAdminEvent( eventId: number, data:any ) {
    return api.put( `api/evento/Update/${eventId}`, data );
  },
  deleteAdminEvent( eventId: number ) {
    return api.delete( `api/evento/Delete/${eventId}` );
  },
  deleteAdminEventFile( eventId: number, data: string[] ) {
    return api.post( `api/evento/DeleteFiles/${eventId}`, data );
  },
  uploadEventFiles( eventId: string, data:File[] ) {
    const formData = new FormData();
    data.forEach( ( file: File ) => {
      formData.append( 'files', file );
    } );

    return api.post( `api/evento/AddFiles/${eventId}`, formData );
  },
};

export default EventsApi;
